var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFsNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.379,
    height: 24.4,
    viewBox: "0 0 24.379 24.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10406",
    "data-name": "Group 10406",
    transform: "translate(-1095.749 -17.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2768",
    "data-name": "Rectangle 2768",
    width: 23.949,
    height: 22.97,
    rx: 3,
    transform: "translate(1096 18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1095.949 17.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M23.582,26H4.4A2.4,2.4,0,0,1,2,23.6V4.4A2.4,2.4,0,0,1,4.4,2H23.582a2.4,2.4,0,0,1,2.4,2.4V23.6a2.4,2.4,0,0,1-2.4,2.4ZM4.4,2.686A1.716,1.716,0,0,0,2.685,4.4V23.6A1.716,1.716,0,0,0,4.4,25.314H23.582A1.716,1.716,0,0,0,25.294,23.6V4.4a1.716,1.716,0,0,0-1.713-1.714Z",
    transform: "translate(-2 -2)",
    fill: "#626262",
    stroke: "#626262",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M52.9,16.517h-.664V12.664H48.385V12h4.186a.332.332,0,0,1,.332.332Z",
    transform: "translate(-33.105 -7.817)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M0,0H8.446V.664H0Z",
    transform: "translate(13.256 10.257) rotate(-45)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M12.664,16.517H12V12.332A.332.332,0,0,1,12.332,12h4.186v.664H12.664Z",
    transform: "translate(-7.818 -7.817)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M0,0H.664V8.446H0Z",
    transform: "translate(4.278 4.754) rotate(-45)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M52.571,52.9H48.385v-.664h3.854V48.385H52.9v4.186A.332.332,0,0,1,52.571,52.9Z",
    transform: "translate(-33.105 -33.086)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M0,0H.664V8.446H0Z",
    transform: "translate(13.255 13.744) rotate(-45)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M16.517,52.9H12.332A.332.332,0,0,1,12,52.571V48.385h.664v3.854h3.854Z",
    transform: "translate(-7.818 -33.086)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M0,0H8.446V.664H0Z",
    transform: "translate(4.277 19.245) rotate(-45)",
    stroke: "#000",
    strokeWidth: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsNormal);
export default __webpack_public_path__ + "static/media/fs-normal.de9441cf.svg";
export { ForwardRef as ReactComponent };